"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9349],{

/***/ 49349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrderItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41717);
/* harmony import */ var _snippets_components_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69342);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






function OrderItem(param) {
    var orderData = param.orderData;
    var ref17, ref1, ref2, ref3, ref4, ref5;
    var orderItemDetail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref6[0], setIsOpen = ref6[1];
    var _ref = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useCustomerOrder)({
        id: orderData === null || orderData === void 0 ? void 0 : orderData.id
    }), order = _ref.order, status = _objectWithoutProperties(_ref, [
        "order"
    ]);
    var toggleOrderDetail = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "order-item flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-item__header w-full md-:pl-7 md-:pr-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md-:w-[18%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-gothamBold md-:hidden",
                                children: "Date"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-light",
                                children: new Date(orderData.processedAt).toLocaleDateString()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md-:w-1/5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-gothamBold md-:hidden",
                                children: "Order"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-gothamBold",
                                children: orderData.name.replace("#", "")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md-:w-1/5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-gothamBold md-:hidden",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-light",
                                children: orderData.fulfillmentStatus === "FULFILLED" ? "Shipped" : "Not shipped"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md-:w-1/5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-gothamBold md-:hidden",
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-light",
                                children: [
                                    "$",
                                    Number.parseFloat((order === null || order === void 0 ? void 0 : (ref17 = order.totalPriceV2) === null || ref17 === void 0 ? void 0 : ref17.amount) || 0, 2)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "md-:w-[22%] md-:!justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            onClick: toggleOrderDetail,
                            className: "button button--outline !w-full",
                            children: isOpen ? "Close" : "View Order"
                        })
                    })
                ]
            }),
            isOpen && status.finished && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-item__details w-full !block",
                ref: orderItemDetail,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-details__status relative flex flex-col md-:flex-row md-:pl-7 md-:pr-5 gap-5 md-:gap-0 py-5 mt-5 border-t border-grey-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "order-details__block md-:w-[18%] pr-2 flex justify-between md-:block",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        className: "md-:mb-5 block",
                                        children: "Payment Status"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block",
                                        children: order.financialStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "order-details__block md-:w-1/5 flex justify-between md-:block",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        className: "md-:mb-5 block",
                                        children: "Shipping Address"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("address", {
                                        className: "text-right md-:text-left",
                                        children: [
                                            (ref1 = order.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.address1,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            (ref2 = order.shippingAddress) === null || ref2 === void 0 ? void 0 : ref2.city,
                                            ", ",
                                            (ref3 = order.shippingAddress) === null || ref3 === void 0 ? void 0 : ref3.province,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            (ref4 = order.shippingAddress) === null || ref4 === void 0 ? void 0 : ref4.zip,
                                            ", ",
                                            (ref5 = order.shippingAddress) === null || ref5 === void 0 ? void 0 : ref5.country
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-item__products-detail relative md-:pl-7 md-:pr-5 pt-5 border-t border-grey-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md-:flex mb-6 md-:mb-9 gap-5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        className: "md-:w-7/12",
                                        children: "Product"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        className: "hidden md-:block md-:w-5/12",
                                        children: "Price"
                                    })
                                ]
                            }),
                            order.lineItems.map(function(item, index) {
                                var ref, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "order__line-item mb-6 md-:mb-9 flex gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "product-container md-:w-7/12",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex gap-5",
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_snippets_components_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
                                                        src: (ref7 = item.variant) === null || ref7 === void 0 ? void 0 : ref7.image.src,
                                                        alt: (ref8 = item.variant) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.altText,
                                                        height: "96",
                                                        width: "96"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "bg-grey-7 flex h-24 w-24 shrink-0 items-center justify-center",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "No Image"
                                                        })
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : (ref10 = item.variant) === null || ref10 === void 0 ? void 0 : ref10.product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                        href: "/products/".concat(item.variant.product.handle),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            className: "no-underline",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                    className: "text-xs",
                                                                    children: item === null || item === void 0 ? void 0 : item.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "md-:hidden",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: "block text-sm",
                                                                        children: [
                                                                            (item === null || item === void 0 ? void 0 : (ref11 = item.discountedTotalPrice) === null || ref11 === void 0 ? void 0 : ref11.amount) < (item === null || item === void 0 ? void 0 : (ref12 = item.originalTotalPrice) === null || ref12 === void 0 ? void 0 : ref12.amount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "line-through mr-1 text-grey-3",
                                                                                children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.originalTotalPrice.amount)
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.discountedTotalPrice.amount)
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                className: "text-xs",
                                                                children: item === null || item === void 0 ? void 0 : item.title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "md-:hidden",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                    className: "block text-sm",
                                                                    children: [
                                                                        (item === null || item === void 0 ? void 0 : (ref13 = item.discountedTotalPrice) === null || ref13 === void 0 ? void 0 : ref13.amount) < (item === null || item === void 0 ? void 0 : (ref14 = item.originalTotalPrice) === null || ref14 === void 0 ? void 0 : ref14.amount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "line-through mr-1 text-grey-3",
                                                                            children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.originalTotalPrice.amount)
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.discountedTotalPrice.amount)
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "price-container hidden md-:block md-:w-5/12 text-sm",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref15 = item.discountedTotalPrice) === null || ref15 === void 0 ? void 0 : ref15.amount) < (item === null || item === void 0 ? void 0 : (ref16 = item.originalTotalPrice) === null || ref16 === void 0 ? void 0 : ref16.amount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "line-through mr-1 text-grey-3",
                                                    children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.originalTotalPrice.amount)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(item === null || item === void 0 ? void 0 : item.discountedTotalPrice.amount)
                                                })
                                            ]
                                        })
                                    ]
                                }, "item-".concat(item.id));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-item__finnancial-details relative md-:pl-7 md-:pr-5 pt-5 border-t border-grey-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-sm flex justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Subtotal"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(order.subtotalPriceV2.amount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-sm flex justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Shipping *"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(order.totalShippingPriceV2.amount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-sm flex justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Taxes *"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(order.totalTaxV2.amount)
                                    })
                                ]
                            }),
                            order.totalRefundedV2.amount !== "0.0" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-sm flex justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Refunded"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            "- ",
                                            (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(order.totalRefundedV2.amount)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full max-w-sm flex justify-between mb-3 border-t pt-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-gothamBold",
                                        children: "Order Total"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-gothamBold",
                                        children: (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_3__/* .formatMoney */ .lb)(parseFloat(order.totalPriceV2.amount) - parseFloat(order.totalRefundedV2.amount))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);